import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../../components/Sidebar";

const SelectProject = () => {
  // 使用React Router的导航钩子
  const navigate = useNavigate();
  // 获取当前location信息
  const location = useLocation();
  // 定义状态变量
  const [projects, setProjects] = useState([]); // 项目列表
  const [loading, setLoading] = useState(true); // 加载状态
  // 从localStorage获取用户ID
  const userId = localStorage.getItem("userId");

  // 从URL参数中获取场景类型
  const searchParams = new URLSearchParams(location.search);
  const scenario = searchParams.get("type");

  useEffect(() => {
      // 如果没有场景类型，重定向到主页
      if (!scenario) {
        navigate("/AppHome");
        return;
      }

      // 保存选中的场景到localStorage
      localStorage.setItem("selectedScenario", scenario);

      // 获取用户角色
      const userRole = localStorage.getItem("userRole");

      // 获取用户的项目列表
      fetch(`/api/projects?user_id=${userId}`)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Failed to fetch projects: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          setProjects(data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching projects:", error);
          setLoading(false);
        });
  }, [navigate, scenario, userId]);

  // 处理项目选择
  const handleProjectSelect = (project) => {
    // 根据场景类型决定跳转页面
    let targetPage = "/app_home";
    if (scenario === "construction")
      targetPage = `/construction_page/${project._id}`;
    if (scenario === "planfile") targetPage = "/planfile_page";
    if (scenario === "marketing") targetPage = "/marketing_page";

    // 保存选中的项目信息到localStorage
    localStorage.setItem(
      "selectedProject",
      JSON.stringify({
        id: project._id,
        name: project.name,
        description: project.description,
      }),
    );

    // 导航到目标页面
    navigate(targetPage);
  };

  // 项目图片映射
  const projectImages = {
    "67 Banbury Road": "/images/67.jpg",
    "5 Peaks": "/images/5peaks.jpg",
    Pointe: "/images/pointe.jpg",
    "27 Country Ln": "/images/27.jpg",
  };

  return (
    <div className="flex h-screen">
      {/* 侧边栏组件 */}
      <Sidebar userRole="admin" scenario={scenario} isProjectSelection={true} />

      <div className="flex flex-col w-full bg-white">
        {/* 顶部Logo */}
        <div className="flex justify-end items-center px-6 py-4 ">
          <img src="/images/gemterra-logo-20260112-t.png" alt="Gemterra" className="w-48" />
        </div>

        {/* 项目列表 */}
        <div className="flex flex-col items-center mt-10">
          {loading ? (
            // 加载中显示
            <p className="text-lg text-gray-600">Loading projects...</p>
          ) : projects.length > 0 ? (
            // 显示项目列表
            <div className="w-full max-w-2xl space-y-6">
              {projects.map((project) => (
                <button
                  key={project._id}
                  onClick={() => handleProjectSelect(project)}
                  className="flex items-center w-full bg-white shadow-md rounded-lg overflow-hidden transition-transform transform hover:scale-105"
                >
                  <img
                    src={projectImages[project.name]}
                    alt={project.name}
                    className="w-60 h-24 object-cover"
                  />
                  <span className="text-lg font-semibold text-gray-800 px-4">
                    {project.name}
                  </span>
                </button>
              ))}
            </div>
          ) : (
            // 没有项目时显示
            <p className="text-gray-600">No projects available for you.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectProject;